/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { NotificationIndexResponse } from '../types/NotificationIndex'

/**
 * GET /notifications
 * @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::index
 */
export async function notificationIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<NotificationIndexResponse>> {
	return axiosInstance.get('/notifications', config)
}
